import React, { useState, useEffect } from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { Form, Container, Row, Col, Card, ListGroup, FloatingLabel } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import Loading from '../../components/Loading/Loading';
import FacturaImage from '../../assets/images/contact-us.jpg'; 
import "../Contact/contact.css";
import ProgressBarLoader from "../../components/ProgressBarLoader/ProgressBarLoader";

const Factura = () => {
    const [loading, setLoading] = useState(false);
    const [invoice, setInvoice] = useState('');
    const [contactData, setContactData] = useState(null);
    const [pageLoading, setPageLoading] = useState(true);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    
    useEffect(() => {
        window.scrollTo(0, 0);
        fetchContactData();
    }, []);

    const fetchContactData = async () => {
        try {
            const response = await axios.get(`${ENDPOINT}get-page-contact/1`);
            if (response.data && response.data.res === true) {
                setContactData(response.data.data);
            }
        } catch (error) {
            console.error('Error al cargar los datos de contacto:', error);
            // Mantener los valores por defecto en caso de error
        } finally {
            setPageLoading(false);
        }
    };
    
    const handlePrint = async (e) => {
        e.preventDefault();
        setLoading(true);
        const user_id = 1;
        const form = new FormData();
        form.append("invoice", invoice);
        form.append("user_id", user_id);

        try {
            const response = await axios.post(ENDPOINT + 'print-pdf-ticket-invoice', form, { responseType: "blob" });
            const url = window.URL.createObjectURL(response.data);
            window.open(url, '_blank');
            setInvoice('');
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se encontró la factura. Verifique el folio.',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loading />}
            <ProgressBarLoader />
            <Breadcrumbs title="Factura" pagename="Factura" />
            <section className="contact pt-1">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="main_heading text-center">
                                <h1 className="text-uppercase">FACTURAS SALINACRUCENSES</h1>
                                <h6 className="h6 text-uppercase mt-3">GENERA TUS FACTURAS CON ESTOS SENCILLOS PASOS</h6>
                            </div>
                        </Col>
                    </Row>

                    {/* Cards vacías con mismo diseño */}
                    <Row className="py-4">
                        <Col lg="6" md="6" className="mb-4 mb-lg-0">
                            <Card className="border shadow rounded-3 mb-4 card-equal-height">
                                <Card.Body className="text-center">
                                    <div className="d-flex justify-content-center align-item-search my-2">
                                        <div className="bg-info rounded-circle text-info shadow-sm bg-opacity-10 p-2">
                                            <i className="bi bi-receipt h3"></i>
                                        </div>
                                    </div>
                                    <p className="mb-3 body-text" style={{ whiteSpace: 'pre-line' }}>
                                        {contactData?.card_1}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg="6" md="6" className="mb-4 mb-lg-0">
                            <Card className="border shadow rounded-3 mb-4 card-equal-height">
                                <Card.Body className="text-center">
                                    <div className="d-flex justify-content-center align-item-search my-2">
                                        <div className="bg-danger rounded-circle text-danger shadow-sm bg-opacity-10 p-2">
                                            <i className="bi bi-exclamation-circle h3"></i>
                                        </div>
                                    </div>
                                    <p className="mb-3 body-text" style={{ whiteSpace: 'pre-line' }}>
                                        {contactData?.card_2}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <section className="iframe-section mt-4" style={{ overflow: 'hidden' }}>
                        <iframe
                            src={contactData?.link_fact}
                            width="100%"
                            height={window.innerWidth < 768 ? '3600px' : '1500px'}
                            style={{ border: "none", overflow: 'hidden' }}
                            loading="lazy"
                            title="Auto Facturación"
                            scrolling="yes"
                            allow="fullscreen"
                        ></iframe>
                    </section>
                </Container>
            </section>
        </>
    );
};

export default Factura;